import { Fragment } from 'react';
import { NavLink, useMatches } from 'react-router-dom';
import { ReactComponent as AppsLine } from '@/assets/icons/apps-line.svg';
import { ReactComponent as ArrowRightSLine } from '@/assets/icons/arrow-right-s-line.svg';
import { CrumbHandle, Match } from '@/components/common/Breadcrumbs/types';

const getCrumbs = (crumbs: Match[]) =>
	crumbs.map((c, index) => {
		const additionalClassName = index === 0 ? 'text-black-primary' : '';
		const { id, pathname, handle } = c;
		const { crumb, isClickable } = handle as CrumbHandle;

		return (
			<Fragment key={id}>
				{isClickable ? (
					<NavLink to={pathname} className={additionalClassName}>
						{crumb}
					</NavLink>
				) : (
					<div className={additionalClassName}>{crumb}</div>
				)}
				{index !== crumbs.length - 1 && <ArrowRightSLine />}
			</Fragment>
		);
	});

const Breadcrumbs = () => {
	const matches: Match[] = useMatches();
	const crumbs = matches.filter(
		(match: Match) =>
			match.handle &&
			Object.prototype.hasOwnProperty.call(match.handle, 'crumb')
	);

	return (
		<div className="flex flex-row justify-start items-center gap-3 text-jsm text-grey-dark">
			<div className="text-black-primary h-[18px] object-contain">
				<AppsLine />
			</div>
			{getCrumbs(crumbs)}
		</div>
	);
};

export default Breadcrumbs;
